import { useQuery } from "@apollo/client";
import { GetRemainingRewardBudgetQuery, GetRemainingRewardBudgetQueryVariables } from "generated/graphql";
import queries from "Shared/queries";

export const useRemainingRewardBudget = () => {
  const { data, loading } = useQuery<
    GetRemainingRewardBudgetQuery,
    GetRemainingRewardBudgetQueryVariables
  >(queries.GET_REMAINING_REWARD_BUDGET);

  return {
    remainingRewardBudget: data?.employer.employerRewardBudget.remainingAmountCents,
    loading,
  };
};
